import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.Drawer.DisabledWorkflowPanel', {
    title: 'Workflow is not activated',
    setupButton: 'Setup',
});
